<div class="container-fluid">
    <div class="header-container row">
        <div class="col-5 pt-4 hidden-small" [style.visibility]="isAdmin() ? 'hidden' : 'visible'">
            <button type="button" class="btn btn-nothing" title="Planning"
                [class.active]="currentRoute() === 'planning'" (click)="navTo('planning')">
                Planning
            </button>
            <button type="button" class="btn btn-nothing" [class.active]="currentRoute() === 'faq'"
                title="FAQ" (click)="navTo('faq')">
                FAQ
            </button>
            <button type="button" class="btn btn-nothing me-2" [class.active]="currentRoute() === 'info'"
                title="Accès et hébergements" (click)="navTo('info')">
                Accès & hébergements
            </button>
        </div>
        <button type="button" class="btn btn-black mt-4 left btn-open-menu" (click)="toggleMenu()" title="Menu"
            [style.right]="isAdmin() ? '5%' : ''" [style.left]="isAdmin() ? '' : '5%'">
            <i class="bi bi-list"></i>
        </button>
        <div class="col-2 home-button">
            <button type="button" class="btn btn-nothing me-2 classy italic centered" (click)="navTo('')">
                M&nbsp;&&nbsp;A
                <br />
                21&nbsp;/&nbsp;08&nbsp;/&nbsp;2027
            </button>
        </div>
        <div class="col-5 hidden-small">
            @if(currentlyLoggedIn() && canAccessAdmin()) {
            <button type="button" class="btn btn-terra me-4 mt-4 right italic" (click)="logOff()" title="Déconnexion">
                <i class="bi bi-box-arrow-left"></i>
                <span class="large-screen">Déconnexion</span>

            </button>
            }

            @if(!canAccessAdmin()) {
            <button type="button" class="btn btn-nothing me-4 right mt-4" (click)="navTo('rsvp')" title="RSVP">
                <i class="bi bi-envelope-open-heart me-2"></i>
                <span class="large-screen">Confirmez votre venue</span>
            </button>
            } @else if(currentlyLoggedIn() && canAccessAdmin()) {
            <button type="button" class="btn btn-black me-4 right mt-4 italic"
                [style.visibility]="isAdmin() ? 'hidden' : 'visible'" (click)="navTo('admin')" title="Admin">
                <i class="bi bi-person-fill-gear"></i>
                <span class="large-screen">Administration</span>
            </button>
            }
        </div>
    </div>

    @if (menuForMobilShown()) {
    <div class="row shown-small">
        <div class="col-12">
            <div class="menu-link" [class.active]="currentRoute() === 'planning'" (click)="navTo('planning')">
                Planning
            </div>
        </div>
        <div class="col-12">
            <div class="menu-link" [class.active]="currentRoute() === 'faq'" (click)="navTo('faq')">
                FAQ
            </div>
        </div>
        <div class="col-12">
            <div class="menu-link" [class.active]="currentRoute() === 'info'" (click)="navTo('info')">
                Accès & hébergements
            </div>
        </div>
        @if(!canAccessAdmin()) {
        <div class="col-12">
            <div class="menu-link" [class.active]="currentRoute() === 'rsvp'" (click)="navTo('rsvp')">
                Confirmez votre venue
            </div>
        </div>
        } @else if(currentlyLoggedIn() && canAccessAdmin()) {
        <div class="col-12">
            <div class="menu-link" (click)="navTo('admin/dashboard')"
                [class]="'dashboard' | adminActiveRoute : currentRoute()">
                <div class="title">Dashboard</div>
            </div>
        </div>
        <div class="col-12">
            <div class="menu-link" (click)="navTo('admin/import')" [class]="'import' | adminActiveRoute : currentRoute()">
                <div class="title">Importer</div>
            </div>
        </div>
        <div class="col-12">
            <div class="menu-link" (click)="navTo('admin/display')" [class]="'display' | adminActiveRoute : currentRoute()">
                <div class="title">Tableau</div>
            </div>
        </div>
        <div class="col-12">
            <div class="menu-link" (click)="navTo('admin/edit-faq')" [class]="'edit-faq' | adminActiveRoute : currentRoute()">
                <div class="title">Modifier FAQ</div>
            </div>
        </div>
        <div class="col-12">
            <div class="menu-link" (click)="navTo('admin/notifs')" [class]="'notifs' | adminActiveRoute : currentRoute()">
                <div class="title">Notifications</div>
            </div>
        </div>
        <div class="col-12">
            <div class="menu-link" (click)="logOff()">
               Déconnexion
            </div>
        </div>
        }
    </div>
    }
</div>
@if(menuForMobilShown()) {
<div class="menu-backdrop" (click)="toggleMenu()"></div>
}